var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { invariant } from "@madmedical/utils";
import { View } from "react-native";
import { BaseButton } from "@madmedical/ui";
import { getRefreshToken, useLogoutMutation } from "@madmedical/store";
const LogoutButton = () => {
    const [logout] = useLogoutMutation();
    const handlePress = () => {
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            const refreshToken = yield getRefreshToken();
            invariant(refreshToken, "refreshToken is required");
            void logout(refreshToken);
        }))();
    };
    return (_jsx(View, { children: _jsx(BaseButton, Object.assign({ onPress: handlePress }, { children: "Log Out" })) }));
};
export default LogoutButton;
